import { getNetwork } from '../utils/getNetwork';
import { API_ROOT } from '../config';

export const getListServiceApi = () => getNetwork().get(`${API_ROOT}/edu-service-registry`);
export const updateServiceApi = (data) =>
  getNetwork().put(`${API_ROOT}/edu-service-registry`, data);
export const createServiceApi = (data) =>
  getNetwork().post(`${API_ROOT}/edu-service-registry`, data);
export const deleteServiceApi = (registryId) =>
  getNetwork().delete(`${API_ROOT}/edu-service-registry/${registryId}`);
